import { render, staticRenderFns } from "./RequestDecisionView.vue?vue&type=template&id=6e8a5a27"
import script from "./RequestDecisionView.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequestDecisionView.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports